<template>
  <div :id="app_gallery" class="bg">
    <!-- <div class="pazuru"> -->
    <div class="fill_sp1"></div>
    <div class=" pazuru ml-3 mr-3 mb-5 pb-5">
      <b-container class="bv-example-row">
        <b-row class="text-center">
          <b-col
            ><GalleryPuzzle
              :data="puzzle1"
              :srcImg="puzzle1.src"
              :song="puzzle1.song"
          /></b-col>
          <b-col
            ><GalleryPuzzle
              :data="puzzle2"
              :srcImg="puzzle2.src"
              :song="puzzle2.song"
          /></b-col>
          <b-col
            ><GalleryPuzzle
              :data="puzzle3"
              :srcImg="puzzle3.src"
              :song="puzzle3.song"
          /></b-col>
        </b-row>
      </b-container>

      <b-container class="bv-example-row">
        <b-row class="text-center">
          <b-col
            ><GalleryPuzzle
              :data="puzzle4"
              :srcImg="puzzle4.src"
              :song="puzzle4.song"
          /></b-col>
          <b-col
            ><GalleryPuzzle
              :data="puzzle5"
              :srcImg="puzzle5.src"
              :song="puzzle5.song"
          /></b-col>
          <b-col
            ><GalleryPuzzle
              :data="puzzle6"
              :srcImg="puzzle6.src"
              :song="puzzle6.song"
          /></b-col>
        </b-row>
      </b-container>

      <b-container class="bv-example-row">
        <b-row class="text-center">
          <b-col
            ><GalleryPuzzle
              :data="puzzle7"
              :srcImg="puzzle7.src"
              :song="puzzle7.song"
          /></b-col>
          <b-col
            ><GalleryPuzzle
              :data="puzzle8"
              :srcImg="puzzle8.src"
              :song="puzzle8.song"
          /></b-col>
          <b-col
            ><GalleryPuzzle
              :data="puzzle9"
              :srcImg="puzzle9.src"
              :song="puzzle9.song"
          /></b-col>
        </b-row>
      </b-container>
    </div>
    <div class="fill_sp2"></div>
  </div>
</template>

<script>
import GalleryPuzzle from "./Gallery_puzzle.vue";

export default {
  name: "gallery",
  components: {
    GalleryPuzzle,
  },
  data: function() {
    return {
      puzzle1: {
        id: 1,
        check: false,
        name: "game_1", //routerのpath名
        src: "puzzle1.jpg", //画像の名前（assets/galleryに入れてね）
        title: "お寺", //画像のタイトル
        song: "puzzle1.mp3", //まとめた音(assets/gallery/songsに入れてね)
      },
      puzzle2: {
        id: 2,
        check: false,
        name: "game_2",
        src: "puzzle2.jpg",
        title: "参拝",
        song: "puzzle2.mp3",
      },
      puzzle3: {
        id: 3,
        check: false,
        name: "game_3",
        src: "puzzle3.jpg",
        title: "日本の川と森",
        song: "puzzle3.mp3",
      },
      puzzle4: {
        id: 4,
        check: false,
        name: "game_4",
        src: "puzzle4.jpg",
        title: "和室①",
        song: "puzzle4.mp3",
      },
      puzzle5: {
        id: 5,
        check: false,
        name: "game_5",
        src: "puzzle5.jpg",
        title: "和室②",
        song: "puzzle5.mp3",
      },
      puzzle6: {
        id: 6,
        check: false,
        name: "game_6",
        src: "puzzle6.jpg",
        title: "河原と滝と車",
        song: "puzzle6.mp3",
      },
      puzzle7: {
        id: 7,
        check: false,
        name: "game_7",
        src: "puzzle7.jpg",
        title: "_京都",
        song: "puzzle7.mp3",
      },
      puzzle8: {
        id: 8,
        check: false,
        name: "game_8",
        src: "puzzle8.jpg",
        title: "小学校",
        song: "puzzle8.mp3",
      },
      puzzle9: {
        id: 9,
        check: false,
        name: "game_9",
        src: "puzzle9.jpg",
        title: "___桃太郎",
        song: "puzzle9.mp3",
      },
    };
  },
  mounted() {
    if (localStorage.check) {
      this.puzzle1.check = localStorage.check;
    }
    if (localStorage.check2) {
      this.puzzle2.check = localStorage.check2;
    }
    if (localStorage.check3) {
      this.puzzle3.check = localStorage.check3;
    }
    if (localStorage.check4) {
      this.puzzle4.check = localStorage.check4;
    }
    if (localStorage.check5) {
      this.puzzle5.check = localStorage.check5;
    }
    if (localStorage.check6) {
      this.puzzle6.check = localStorage.check6;
    }
    if (localStorage.check7) {
      this.puzzle7.check = localStorage.check7;
    }
    if (localStorage.check8) {
      this.puzzle8.check = localStorage.check8;
    }
    if (localStorage.check9) {
      this.puzzle9.check = localStorage.check9;
    }
  },
};
</script>

<style>
#app_gallery {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: right;
  /* margin-top: 60px;
  padding-top:40px; */
}
.bg {
  background-color: #faffd1;
}
.pazuru {
  /* margin-top:50px; */
  padding-left: 3%;
  border-radius: 4%;
  background-color: #e5f56f;
}
.fill_sp1 {
  background-color: #faffd1;
  height: 50px;
}
.fill_sp2 {
  background-color: #faffd1;
  height: 20px;
}
</style>
